module.exports = __webpack_public_path__ + "static/media/certn_integration_ss_5.65ac70bb.png";